<template>
  <div>
    <b-form-group
      label-cols-sm="3"
      label="Wysokość mieszkania"
      label-for="email"
      v-if="items.length !== 0"
    >
      <b-form-input
        type="text"
        class="form-control"
        :value="height"
        :formatter="numberFormat"
        :state="errors.height"
        @change="saveHeight"
        style="width:94px"
        :readonly="!isNotSubcontractor"
      />
    </b-form-group>
    <table
      class="table table-sm table-list m-0 table-mobile table-hover measurement-table"
    >
      <thead>
        <tr style="border:none">
          <th>Pomieszczenie</th>
          <th class="text-center">Szerokość</th>
          <th class="text-center">Długość</th>
          <th class="text-left">Rodzaj podłogi</th>
          <th class="text-center">
            Podwieszany
            <br />sufit
          </th>
          <th class="text-center">
            Tapety
            <br />Ściany
          </th>
          <th class="text-center">
            Tapety
            <br />Sufit
          </th>
          <th v-if="isNotSubcontractor"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="items.length === 0">
        <td colspan="8" style="vertical-align: middle;">
          <div class="empty">
            <i class="fas fa-door-open empty-state"></i>
            <span class="empty-search">Brak Pomieszczeń</span>
          </div>
        </td>
        </tr>
        <tr v-for="(item, index) in items" :key="index">
          <template v-if="item.isEdited === false">
            <td class="td-name" data-label="Pomieszczenie">{{roomName(item.name)}}</td>
            <td data-label="Szerokość">{{ parseFloat(item.width).toFixed(2) }}</td>
            <td data-label="Długość">{{ parseFloat(item.lenght).toFixed(2) }}</td>
            <td class="td-floor" data-label="Rodzaj podłogi">{{floorName(item.floor)}}</td>
            <td data-label="Podwieszany sufit">
              <i class="fas fa-check text-success" v-if="item.suspendedceiling ==='1'"></i>
              <i class="fas fa-minus text-muted" v-else></i>
            </td>
            <td data-label="Tapety ściany">
              <i class="fas fa-check text-success" v-if="item.wallpapertoremove_walls ==='1'"></i>
              <i class="fas fa-minus text-muted" v-else></i>
            </td>
            <td data-label="Tapety sufit">
              <i class="fas fa-check text-success" v-if="item.wallpapertoremove_ceiling ==='1'"></i>
              <i class="fas fa-minus text-muted" v-else></i>
            </td>
            <td v-if="isNotSubcontractor">
              <button class="btn btn-outline-danger" @click="remove(index)">
                <i class="far fa-trash-alt"></i>
              </button>
              <button class="btn btn-outline-primary" @click="startEdit(item)">
                <i class="fas fa-pencil-alt"></i>
              </button>
            </td>
          </template>
          <template v-else>
            <td class="td-name" data-label="Pomieszczenie">
              <b-form-select v-model="formEdited.name" :options="roomTypes"></b-form-select>
            </td>
            <td data-label="Szerokość">
              <b-form-input
                v-model="formEdited.width"
                type="text"
                placeholder="0.00"
                :formatter="numberFormat"
                :state="errors.edited_width"
                @change="isValidSize(formEdited.width, 'edited_width')"
              ></b-form-input>
            </td>
            <td data-label="Długość">
              <b-form-input
                v-model="formEdited.lenght"
                type="text"
                placeholder="0.00"
                :formatter="numberFormat"
                :state="errors.edited_lenght"
                @change="isValidSize(formEdited.lenght, 'edited_lenght')"
              ></b-form-input>
            </td>
            <td class="td-floor" data-label="Rodzaj podłogi">
              <b-form-select v-model="formEdited.floor" :options="floorTypes" class="small"></b-form-select>
            </td>
            <td data-label="Podwieszany sufit">
              <b-form-checkbox
                v-model="formEdited.suspendedceiling"
                name="suspendedceiling"
                value="1"
                unchecked-value="0"
              ></b-form-checkbox>
            </td>
            <td data-label="Tapety ściany">
              <b-form-checkbox
                v-model="formEdited.wallpapertoremove_walls"
                name="wallpapertoremove_walls"
                value="1"
                unchecked-value="0"
              ></b-form-checkbox>
            </td>
            <td data-label="Tapety sufit">
              <b-form-checkbox
                v-model="formEdited.wallpapertoremove_ceiling"
                name="wallpapertoremove_ceiling"
                value="1"
                unchecked-value="0"
              ></b-form-checkbox>
            </td>
            <td>
              <button
                class="btn btn-outline-success mb-2 btn-edit"
                @click="storeEdited"
                :disabled="!$_.isNull(errors.edited_lenght) || !$_.isNull(errors.edited_width)"
              >Zapisz</button>
              <button class="btn btn-outline-secondary mb-2 btn-delete" @click="resetEdit">
                <i class="fas fa-times"></i>
              </button>
            </td>
          </template>
        </tr>
        <template v-if="isNotSubcontractor">
          <tr>
            <td colspan="8" class="text-left">
              <strong>Dodaj pomieszczenie</strong>
            </td>
          </tr>
          <tr>
            <td data-label="Pomieszczenie">
              <b-form-select v-model="form.name" :options="roomTypes"></b-form-select>
            </td>
            <td data-label="Szerokość">
              <b-form-input
                v-model="form.width"
                type="text"
                :formatter="numberFormat"
                :state="errors.width"
                @change="isValidSize(form.width, 'width')"
                placeholder="0.00"
              ></b-form-input>
            </td>
            <td data-label="Długość">
              <b-form-input
                v-model="form.lenght"
                type="text"
                :formatter="numberFormat"
                :state="errors.lenght"
                @change="isValidSize(form.lenght, 'lenght')"
                placeholder="0.00"
              ></b-form-input>
            </td>
            <td data-label="Rodzaj podłogi">
              <b-form-select v-model="form.floor" :options="floorTypes" class="small"></b-form-select>
            </td>
            <td data-label="Podwieszany sufit">
              <b-form-checkbox
                v-model="form.suspendedceiling"
                name="suspendedceiling"
                value="1"
                unchecked-value="0"
              ></b-form-checkbox>
            </td>
            <td data-label="Tapety ściany">
              <b-form-checkbox
                v-model="form.wallpapertoremove_walls"
                name="wallpapertoremove_walls"
                value="1"
                unchecked-value="0"
              ></b-form-checkbox>
            </td>
            <td data-label="Tapety sufit">
              <b-form-checkbox
                v-model="form.wallpapertoremove_ceiling"
                name="wallpapertoremove_ceiling"
                value="1"
                unchecked-value="0"
              ></b-form-checkbox>
            </td>
            <td>
              <button
                class="btn btn-outline-primary m-0"
                @click="appendRoom"
                :disabled="!this.$_.isNull(errors.lenght) || !this.$_.isNull(errors.width)"
              >Dodaj</button>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { numberFormat } from "@/services/helpers";

export default {
  name: "MeasurementRooms",
  props: {
    rooms: {
      type: Array
    },
    height: {
      type: [Number, String]
    }
  },
  data() {
    return {
      errors: {
        height: null,
        width: null,
        lenght: null,
        edited_width: null,
        edited_lenght: null
      },
      items: [],
      selected: false,
      formEdited: false,
      form: {
        name: "room",
        width: 0.0,
        lenght: 0.0,
        floor: "wood",
        suspendedceiling: false,
        wallpapertoremove_walls: false,
        wallpapertoremove_ceiling: false
      },
      roomTypes: [
        //room,hall,kitchen,cell,toilet
        { text: "Pokój", value: "room" },
        { text: "Korytarz / Przedpokój", value: "hall" },
        { text: "Kuchnia", value: "kitchen" },
        { text: "Komórka", value: "cell" },
        { text: "Łazienka", value: "bathroom" },
        { text: "WC", value: "toilet" }
      ],
      floorTypes: [
        { text: "Drewniana", value: "wood" },
        { text: "Kafelki", value: "tiles" }
      ]
    };
  },
  computed: {
    ...mapGetters("user", ["isNotSubcontractor"]),
    validEditWidth() {
      let width = parseFloat(this.formEdited.width);
      return width >= 0 && width <= 999 ? null : false;
    }
  },
  created() {
    if (this.rooms.length > 0) {
      this.$_.each(this.rooms, item => {
        this.items.push({
          name: item.name,
          width: item.width,
          lenght: item.lenght,
          floor: item.floor,
          suspendedceiling: item.suspendedceiling,
          wallpapertoremove_walls: item.wallpapertoremove_walls,
          wallpapertoremove_ceiling: item.wallpapertoremove_ceiling,
          isEdited: false
        });
      });
    }
  },
  methods: {
    ...mapActions("construction", ["measurementHeight", "measurementRooms"]),
    numberFormat: numberFormat,
    saveHeight(newValue) {
      this.isValidSize(this.height, "height");
      if (this.errors.height === false || newValue === this.height) return;
      this.measurementHeight(newValue);
    },
    saveRooms() {},
    startEdit(item) {
      if (this.selected) {
        this.selected.isEdited = false;
      }
      this.selected = item;
      item.isEdited = true;
      this.errors.edited_width = null;
      this.errors.edited_lenght = null;
      this.formEdited = {};
      this.$_.each(item, (v, k) => {
        this.formEdited[k] = v;
      });
      this.formEdited.lenght = parseFloat(this.formEdited.lenght).toFixed(2);
      this.formEdited.width = parseFloat(this.formEdited.width).toFixed(2);
    },
    resetEdit() {
      if (this.selected) {
        this.selected.isEdited = false;
      }
      this.selected = false;
      this.formEdited = false;
    },
    appendRoom() {
      let newItem = {
        isEdited: false
      };
      let itemsClone = JSON.parse(JSON.stringify(this.items));
      this.$_.each(this.form, (v, k) => {
        newItem[k] = v;
      });
      itemsClone.push(newItem);
      this.$Progress.start();
      this.measurementRooms(itemsClone).then(() => {
        this.items.push(this.$_.clone(newItem));
        this.resetForm();
      });
    },
    storeEdited() {
      if (this.$_.isEqual(this.selected, this.formEdited) === true) {
        this.resetEdit();
        return;
      }
      let cloneItems = JSON.parse(JSON.stringify(this.items));
      let cloneSelected = this.$_.find(cloneItems, { isEdited: true });
      this.$_.each(this.formEdited, (v, k) => {
        cloneSelected[k] = v;
      });
      this.$Progress.start();
      this.measurementRooms(cloneItems).then(() => {
        this.$_.each(this.formEdited, (v, k) => {
          this.selected[k] = v;
        });
        this.resetEdit();
      });
    },
    remove(index) {
      this.$bvModal
        .msgBoxConfirm("Czy na pewno chcesz usunąć ten element?", {
          title: "Potwierdź usunięcie pokoju",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO"
        })
        .then(result => {
          if (result === true) {
            let cloneItems = JSON.parse(JSON.stringify(this.items));
            cloneItems.splice(index, 1);
            this.measurementRooms(cloneItems).then(() => {
              this.items.splice(index, 1);
            });
          }
        });
      //
    },
    resetForm() {
      this.form = {
        name: "room",
        width: 0,
        lenght: 0,
        floor: "wood",
        suspendedceiling: false,
        wallpapertoremove_walls: false,
        wallpapertoremove_ceiling: false
      };
    },
    roomName(type) {
      return this.$_.find(this.roomTypes, { value: type }).text || "undefined";
    },
    floorName(type) {
      return this.$_.find(this.floorTypes, { value: type }).text || "undefined";
    },
    isValidSize(size, errorName) {
      let number = parseFloat(size);
      this.errors[errorName] =
        parseFloat(number) >= 0 && parseFloat(number) <= 999 ? null : false;
    }
  }
};
</script>